import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Card, Row, Col, Skeleton, Button, Slider, message } from "antd";
import { SketchPicker } from "react-color";
import axiosInstance from "../../../axiosInterceptor";

const FooterConfig = () => {
  const accessToken = window.localStorage.getItem("accessToken");

  const [loading, setLoading] = useState(false);
  const [loja, setLoja] = useState(null);
  const idUser = window.localStorage.getItem("idUser");
  const [idLoja, setIDLoja] = useState(null);
  const [reload, setReload] = useState(true);



  const [footerTextColor, setFooterTextColor] = useState("#000");
  const [firstFooterColor, setFirstFooterColor] = useState("#ffffff");
  const [secondFooterColor, setSecondFooterColor] = useState("#000000");
  const [gradientDirection, setGradientDirection] = useState(45);

  const handleSliderChange = (value) => {
    setGradientDirection(value);
  };

  const parseGradient = (gradientString) => {
    const regex = /linear-gradient\((\d+)deg,\s*(#[a-fA-F0-9]{6}),\s*(#[a-fA-F0-9]{6})\)/;
    const matches = gradientString.match(regex);
    if (matches) {
      return {
        direction: parseInt(matches[1], 10),
        color1: matches[2],
        color2: matches[3],
      };
    }
    return null;
  };



  useEffect(() => {
    if (idUser) {
      const options = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      };
      axiosInstance.get(
        `https://techfood-api.herokuapp.com/v1/restaurantes/usuario/${idUser}`,
        options
      ).then((resp) => {
        setIDLoja(resp.data.id);
        setLoja(resp.data);
      });
    }
  }, [idUser]);

  const handleSave = () => {
    const jsonData = {
       
        FooterTextColors: footerTextColor,
        FooterBackground: `linear-gradient(${gradientDirection}deg, ${firstFooterColor}, ${secondFooterColor})`,
      
    };

    let body = JSON.stringify(jsonData);
    try {
      setLoading(true);
      const options = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      };

      axiosInstance.put(
        `https://api.pedtech.com.br/v1/pedtech/footerSessaoCor/`+idLoja,
        body,
        options
      ).then((resp) => {
        if (resp.status === 200) {
          message.success("Cores do rodapé salvas!");
        }
        setLoading(false);
      }).catch((error) => {
        console.error("Erro ao chamar a API:", error.status);
        message.error("Erro ao gravar as cores do rodapé!");
        setLoading(false);
      });

    } catch (error) {
      console.error("Erro ao chamar a API:", error);
      message.error("Erro ao gravar as cores do rodapé!");
      setLoading(false);
    }
  };

  const loadDados = () => {
    setLoading(true);
    const options = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
    };
    axiosInstance.get(
      `https://api.pedtech.com.br/v1/pedtech/getByEmpresa/`+idLoja,
      options
    ).then((resp) => {
      const footerColors = resp.data.FooterColors;
      console.log(footerColors);
      setFooterTextColor(footerColors.FooterTextColors);

      const parsedGradient = parseGradient(footerColors.FooterBackground);
      if (parsedGradient) {
        setGradientDirection(parsedGradient.direction);
        setFirstFooterColor(parsedGradient.color1);
        setSecondFooterColor(parsedGradient.color2);
      }

      setLoading(false);
    }).catch((error) => {
      console.error("Erro ao carregar dados:", error);
      setLoading(false);
    });
  };

  useEffect(() => {
    setLoading(true);
    if (idUser && idLoja) {
      loadDados();
    }
  
  }, [idUser, accessToken, reload, idLoja]);


  return (
    <Container>
      <Card style={{ width: "80%", marginTop: "140px", marginBottom: "110px" }}>
        <h1 style={{ textAlign: "center" }}>Configuração de Cores do Rodapé</h1>

        {loading ? (
          <Skeleton active />
        ) : (
          <>
            <Row gutter={[16, 16]} style={{ marginTop: "20px", display: "flex", justifyContent: "center" }}>
              <Col xs={24} md={12} lg={7}>
                <h3>Primeira Cor do Fundo do Rodapé:</h3>
                <SketchPicker
                  color={firstFooterColor}
                  onChangeComplete={(color) => setFirstFooterColor(color.hex)}
                  disableAlpha={true}
                />
              </Col>
              <Col xs={24} md={12} lg={7}>
                <h3>Segunda Cor do Fundo do Rodapé:</h3>
                <SketchPicker
                  color={secondFooterColor}
                  onChangeComplete={(color) => setSecondFooterColor(color.hex)}
                  disableAlpha={true}
                />
              </Col>
              <Col xs={24} md={12} lg={7}>

   
                <h3>Direção do Gradiente do Fundo: {gradientDirection}°</h3>
                <Slider
                  min={0}
                  max={360}
                  value={gradientDirection}
                  onChange={handleSliderChange}
                />
           

                <div style={{ textAlign: "center" }}>
                  <h3>Rodapé Preview</h3>
                  <div
                    style={{
                      background: `linear-gradient(${gradientDirection}deg, ${firstFooterColor}, ${secondFooterColor})`,
                      //width: "100px",
                      height: "100px",
                      marginTop: "20px",
                      borderRadius: "8px",
                      textAlign: "center",
                      color: footerTextColor,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}
                  >
                    <p>Texto Preview</p>
                  </div>
                </div>
              </Col>
            </Row>

            <Row gutter={[16, 16]} style={{ marginTop: "20px", display: "flex", justifyContent: "center" }}>

              <Col xs={24} md={12} lg={7}>
                <h3>Cor do Texto do Rodapé:</h3>
                <SketchPicker
                  color={footerTextColor}
                  onChangeComplete={(color) => setFooterTextColor(color.hex)}
                  disableAlpha={true}
                />
              </Col>

              
              <div style={{ textAlign: "center" }}>
                  <h3>Rodapé Preview</h3>
                  <div
                    style={{
                      background: `linear-gradient(${gradientDirection}deg, ${firstFooterColor}, ${secondFooterColor})`,
                      width: "100px",
                      height: "100px",
                      marginTop: "20px",
                      borderRadius: "8px",
                      textAlign: "center",
                      color: footerTextColor,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}
                  >
                    <p>Texto Preview</p>
                  </div>
                </div>
            </Row>

            <div style={{ marginTop: "20px", textAlign: "center" }}>
              <Button type="primary" onClick={handleSave}>
                Salvar
              </Button>
            </div>
          </>
        )}
      </Card>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export default FooterConfig;
